import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { CareersBrandingCard } from '../components/settings/CareersBrandingCard';

const INTEGRATIONS = [
  { name: 'SendGrid', status: 'active', color: '#0076A3' },
  { name: 'Google OAuth', status: 'active', color: '#059669' },
  { name: 'OpenAI GPT-5.2', status: 'active', color: '#F2600C' },
  { name: 'MongoDB', status: 'active', color: '#059669' },
  { name: 'Polygon (Simulated)', status: 'ready', color: '#D97706' },
  { name: 'WhatsApp', status: 'planned', color: '#94A3B8' },
  { name: 'Stripe', status: 'planned', color: '#94A3B8' },
  { name: 'LinkedIn OAuth', status: 'planned', color: '#94A3B8' },
];

export default function SettingsPage() {
  const { user } = useAuth();

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Settings</h1>
          <p className="page-subtitle">Platform configuration and integrations</p>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '1.5rem' }}>
        {/* Organization */}
        <Card style={{ background: '#fff', border: '1px solid #ECE7DE', borderRadius: 14, padding: '1.5rem' }}>
          <h3 style={{ fontFamily: 'Cabinet Grotesk', fontSize: '1rem', fontWeight: 600, color: '#0076A3', marginBottom: '1.25rem' }}>Organisation</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0.625rem 0', borderBottom: '1px solid #F1F5F9' }}>
              <span style={{ fontSize: '0.8125rem', color: '#64748B' }}>Company</span>
              <span style={{ fontSize: '0.8125rem', fontWeight: 600, color: '#0076A3' }}>CHIRE</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0.625rem 0', borderBottom: '1px solid #F1F5F9' }}>
              <span style={{ fontSize: '0.8125rem', color: '#64748B' }}>Plan</span>
              <span style={{ fontSize: '0.8125rem', fontWeight: 600, color: '#0076A3' }}>Growth · Monthly</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0.625rem 0', borderBottom: '1px solid #F1F5F9' }}>
              <span style={{ fontSize: '0.8125rem', color: '#64748B' }}>Admin</span>
              <span style={{ fontSize: '0.8125rem', fontWeight: 600, color: '#0076A3' }}>{user?.name} ({user?.email})</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0.625rem 0' }}>
              <span style={{ fontSize: '0.8125rem', color: '#64748B' }}>Role</span>
              <span style={{ fontSize: '0.8125rem', fontWeight: 600, color: '#0076A3', textTransform: 'capitalize' }}>{user?.role}</span>
            </div>
          </div>
        </Card>
      </div>

      {/* Careers page branding */}
      <div style={{ marginTop: '1.5rem' }}>
        <CareersBrandingCard />
      </div>

      {/* Integrations */}
      <Card style={{ background: '#fff', border: '1px solid #ECE7DE', borderRadius: 14, padding: '1.5rem', marginTop: '1.5rem' }}>
        <h3 style={{ fontFamily: 'Cabinet Grotesk', fontSize: '1rem', fontWeight: 600, color: '#0076A3', marginBottom: '1.25rem' }}>Active Integrations</h3>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.625rem' }}>
          {INTEGRATIONS.map(ig => (
            <div key={ig.name} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 0.875rem', borderRadius: 10, border: '1px solid #ECE7DE', background: '#FAFBFC' }}>
              <div style={{ width: 8, height: 8, borderRadius: '50%', background: ig.color }} />
              <span style={{ fontSize: '0.8125rem', fontWeight: 500, color: '#0076A3' }}>{ig.name}</span>
              <Badge style={{ background: ig.status === 'active' ? '#F0FDF4' : ig.status === 'ready' ? '#FFFBEB' : '#F1EAE1', color: ig.status === 'active' ? '#059669' : ig.status === 'ready' ? '#D97706' : '#94A3B8', borderRadius: 999, fontSize: '0.5625rem', border: 'none' }}>{ig.status}</Badge>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
